// Constants Types
import {
  IDTF_ECG_CONFIRM_REQUEST,
  IDTF_ECG_CONFIRM_SUCCESS,
  IDTF_ECG_CONFIRM_FAILURE,
} from './types';

const initialState = {
  isRequesting: false,
  confirmed: false,
  error: {},
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [IDTF_ECG_CONFIRM_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [IDTF_ECG_CONFIRM_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
    confirmed: true,
  }),
  [IDTF_ECG_CONFIRM_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    confirmed: false,
    error: action.payload,
  }),
  // [CLEAR_STATE]: (state, action) => ({ ...initialState }),
};

//
// Reducer
// ------------------------------------
export const KardiaRxIDTFEcgConfirm = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};



// WEBPACK FOOTER //
// ./src/views/state/kardiaRxIdtf/KardiaRxIDTFEcgConfirmReducers.js